<fm-balloon-header
  [avatar]="(balloon?.avatar$ | async) || defaultAvatar"
  color="black"
  [defaultAvatar]="defaultAvatar"
  [title]="balloon?.name"
  [showCriticalHealth]="hasHealthStatusViewPermission && showDeviceHealthDetails"
  [deviceHealthStatus]="this.vehicleHealthStatus?.healthStatus ?? ''"
  [deviceType]="EPlotType.asset"
></fm-balloon-header>

<fm-balloon-section *ngIf="hasHealthStatusViewPermission && showDeviceHealthDetails">
  <fm-device-health-balloon-section
    [vehicleHealthStatus]="this.vehicleHealthStatus"
    [hasPermissionForCameras]="hasCameraIssuesViewPermission"
    [hasPermissionToViewHealthStatus]="hasHealthStatusViewPermission"
    [deviceType]="EPlotType.asset"
  ></fm-device-health-balloon-section>
</fm-balloon-section>

<fm-balloon-section id="asset-balloon-standard-elements">
  <span> <span i18n="@@S_LAST_UPDATE">Last update</span>: {{ balloon?.lastUpdate }} </span>

  <span>{{ balloon?.address }}</span>
</fm-balloon-section>
<fm-balloon-section>
  <fm-asset-battery-balloon-section [remainingBatteryPercentage]="balloon?.remainingBatteryPercentage"></fm-asset-battery-balloon-section>
</fm-balloon-section>
<fm-balloon-actions>
  <button
    mat-button
    class="vzc-small"
    a7s-id="live-map-asset-balloon-zoom-to"
    i18n="@@S_ZOOM_TO"
    [disabled]="disableZoomTo"
    (click)="onZoomTo()"
  >
    Zoom To
  </button>
  <button
    mat-button
    class="vzc-small"
    a7s-id="live-map-asset-balloon-street-view"
    i18n="@@S_STREETVIEW"
    [disabled]="!isStreetViewAvailable"
    (click)="onStreetView()"
  >
    Street View
  </button>
  <button
    mat-button
    class="vzc-small"
    *ngIf="permissions?.replay !== EPermissionStatus.Disabled"
    a7s-id="live-map-asset-balloon-replay"
    i18n="@@S_REPLAY"
    (click)="onReplay()"
  >
    Replay
  </button>
</fm-balloon-actions>
